import { useSelector } from 'react-redux'
import { selectTranslations } from '../../../services/i18n/i18nSlice'
import { Form, Modal, Tab, Tabs } from "react-bootstrap";
import AddUserInput from '../../UsersScreen/_components/AddUserInput';
import { useState } from 'react';

import close_img from '../../../assets/images/close.svg'
import trash_img from '../../../assets/images/trash.svg'
import UserReducedTable from '../../UsersScreen/_components/UserReducedTable';
import GroupReducedTable from '../../UsersScreen/_components/GroupReducedTable';
import { toast } from "react-toastify";
import AddGroupInput from '../../UsersScreen/_components/AddGroupInput';


export default function FolderPermissions (props) {

     const t = useSelector(selectTranslations)

    const handleAllowedAllChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        props.onFolderDataChange({
            ...props.folderData,
            [name]: value === "true" ? true : false
        })
    }

    const [usersRowSelection, setUsersRowSelection] = useState({})
    const [groupsRowSelection, setGroupsRowSelection] = useState({})

    const handleAddUser = (user) => {
        if(user && !props.folderData?.allowed_users?.find(u => u.user_id === user?.user_id)){
            props.onFolderDataChange({
                ...props.folderData,
                allowed_users: [...props.folderData?.allowed_users || [], user]
            })
        } else {
            toast.error(t.groups.error_adding_user)
        }
    }

    const handleAddGroup = (group) => {
        if(group && !props.folderData?.allowed_groups?.find(u => u.group_id === group?.group_id)){
            props.onFolderDataChange({
                ...props.folderData,
                allowed_groups: [...props.folderData?.allowed_groups || [], group]
            })
        } else {
            toast.error(t.groups.error_adding_group)
        }
    }

    const handleRemoveUsers = async () => {
        const users_ids = Object.keys(usersRowSelection)
        
        props.onFolderDataChange({
            ...props.folderData,
            allowed_users: props.folderData?.allowed_users.filter((e) => !users_ids.includes(e.user_id))
        })
    }

    const handleRemoveGroups = () => {
        const group_ids = Object.keys(groupsRowSelection)
        props.onFolderDataChange({
            ...props.folderData,
            allowed_groups: props.folderData?.allowed_groups.filter((e) => !group_ids.includes(e.group_id))
        })
    }
 
    return (
        <Modal
            show={props.show}
            onHide={props.onClose}
            keyboard={true}
            centered
            size='xl'
        >
            <Modal.Body>
                <div className='d-flex justify-content-end mb-2'>
                    <img src={close_img} className='pointer' onClick={props.onClose} />
                </div>
            <div className="info_card">
                <h2>{t.exam.recipient_type} "{props.folderData.name}"</h2>
                <div className='mt-3'>
                    <Form.Check
                        inline
                        label={t.permissions.all_students}
                        name="allowed_all"
                        type={'radio'}
                        id="all"
                        value={true}
                        checked={props.folderData?.allowed_all || false}
                        onChange={handleAllowedAllChange}
                    />
                    <Form.Check
                        inline
                        label={t.permissions.single_students_or_group}
                        name="allowed_all"
                        type={'radio'}
                        id="specific"
                        value={false}
                        checked={!props.folderData?.allowed_all || false}
                        onChange={handleAllowedAllChange}
                    />
                </div>
            </div>
            {
                !props.folderData?.allowed_all ?
                <>
                    <Tabs
                        defaultActiveKey="users"
                        id="noanim-tab-example"
                        className="mt-3 mb-4 rounded_tabs"
                    >
                        <Tab eventKey="users" title={`${t.permissions.single_students} (${props.folderData?.allowed_users?.length || 0})`}>
                            <div className="d-flex justify-content-between mb-2">
                                <AddUserInput onAddUser={handleAddUser} invalidUsers={props.folderData?.allowed_users?.map(u => u.user_id)} label={t.groups.add_user}/>
                                <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                                    <div className='d-flex table_action' onClick={Object.keys(usersRowSelection).length > 0 ? handleRemoveUsers : null} disabled={Object.keys(usersRowSelection).length <= 0}>
                                        <img src={trash_img} />
                                        {t.groups.remove_user}
                                    </div>
                                </div>
                            </div>
                            <UserReducedTable data={props.folderData?.allowed_users} rowSelection={usersRowSelection} setRowSelection={setUsersRowSelection} />
                        </Tab>
                        <Tab eventKey="groups" title={`${t.permissions.groups} (${props.folderData?.allowed_groups?.length || 0})`}>
                            <div className="d-flex justify-content-between mb-2">
                                <AddGroupInput onAddGroup={handleAddGroup} invalidGroups={props.folderData?.allowed_groups?.map(g => g.group_id)} label={t.groups.add_group}/>
                                <div className='d-flex pointer' style={{color:"#181818",fontWeight:"500"}}>
                                    <div className='d-flex table_action' onClick={Object.keys(groupsRowSelection).length > 0 ? handleRemoveGroups : null} disabled={Object.keys(groupsRowSelection).length <= 0}>
                                        <img src={trash_img} />
                                        {t.groups.remove_group}
                                    </div>
                                </div>
                            </div>
                            <GroupReducedTable data={props.folderData?.allowed_groups} rowSelection={groupsRowSelection} setRowSelection={setGroupsRowSelection} />
                        </Tab>
                    </Tabs>

                </> : null
            }
            <>
            </>
            </Modal.Body>
        </Modal>
        
    )
}